<template>
  <BaseVeeForm
    :action="updateTagCategory"
    ensure-error-keys-camel-case
    v-slot="{ isPending, invalid }"
    class="space-y-8"
  >
    <VModal ref="modal" @modal:hidden="$emit('hide')" :disable-backdrop-click="isPending">
      <div class="mx-auto w-full max-w-lg">
        <BaseCard>
          <BaseCardHeader> Edit Tag Category </BaseCardHeader>
          <BaseCardBody>
            <ValidationProvider rules="required" name="name" slim vid="name">
              <template #default="{ errors }">
                <BaseFormGroup>
                  <BaseFormLabel>Name</BaseFormLabel>
                  <BaseFormInput v-model="formData.name" />
                  <BaseFormInlineMessage v-if="errors.length" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </template>
            </ValidationProvider>
          </BaseCardBody>
          <BaseCardFooter>
            <div class="flex space-x-2">
              <BaseButton primary :disabled="invalid || isPending"> Save </BaseButton>
              <BaseButton
                type="button"
                primary
                outline
                :disabled="isPending"
                @click="$refs.modal.close()"
              >
                Cancel
              </BaseButton>
            </div>
          </BaseCardFooter>
        </BaseCard>
      </div>
    </VModal>
  </BaseVeeForm>
</template>

<script>
export default {
  props: {
    action: {
      type: Function,
      required: true,
    },
    tagCategory: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      creating: false,
      formData: {
        name: this.tagCategory.name,
      },
    };
  },
  methods: {
    async updateTagCategory() {
      try {
        const response = await this.action(this.tagCategory.id, this.formData);

        this.$emit('tag-category-updated', response.data);

        this.$refs.modal.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
